/**
 * Route for `kpi-instructions-shown-to-publisher`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { KpiInstructionsShownToPublisherPage } from "../features/kpi-instructions-shown-to-publisher/KpiInstructionsShownToPublisherPage";

export const kpiInstructionsShownToPublisherRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/kpi-instructions-shown-to-publisher",
	component: KpiInstructionsShownToPublisherPage,
});

export default kpiInstructionsShownToPublisherRoute;
